import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Utils from "../utils/utils";
import { fetchUserData } from "../actions/userActions";
import axios from "axios";
import { useToast } from "../components/ToastContext";
import StudentProfileVerification from "../components/StudentProfileVerification";
import StudentDashboard from "../components/StudentProgress/StudentDashboard";

const Dashboard = () => {
  const token = Utils.getToken();
  const dispatch = useDispatch();
  const [isVisible, setIsVisible] = useState(false);
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const { user, loading, error } = useSelector((state) => state.user);

  const showToast = useToast();

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div
      className={`shadow-none p-4 overflow-y-auto space-y-4 h-[calc(100vh-65px)] transition-transform duration-700 ease-in-out transform ${
        isVisible
          ? "translate-x-0 opacity-100"
          : "translate-x-[-100%] opacity-0"
      }`}
    >
      <div className="text-center">
        <div className="flex flex-col items-center gap-2">
          <div className="flex items-center gap-2">
            <img
              src="https://raw.githubusercontent.com/nixin72/nixin72/master/wave.gif"
              alt="Hi"
              className="w-8"
            />
            <p className="text-3xl font-semibold text-gray-800">
              {Utils.getUserFirstName(user.name)},
            </p>
          </div>
          <p className="text-lg text-gray-600">Welcome to Your Dashboard!</p>
        </div>
        <p className="text-gray-700 text-md mt-2 max-w-2xl mx-auto">
          Explore resources and courses designed to help you excel in your
          learning journey.
        </p>
      </div>

      {user && user.role === "student" && !user.verified && (
        <StudentProfileVerification user={user} />
      )}

      <StudentDashboard student={user} />

      <div className="bg-white shadow-md rounded-lg p-6">
        <h2 className="text-2xl font-semibold text-gray-800 mb-3">
          Getting Started 🚀
        </h2>
        <ul className="list-disc list-inside text-gray-600 space-y-2">
          <li>Enroll in courses that match your interests.</li>
          <li>Access exclusive learning materials and resources.</li>
          <li>Connect with instructors for guidance.</li>
        </ul>
      </div>
      <div className="text-center">
        <h2 className="text-xl font-semibold text-gray-800 mb-3">
          Ready to Begin?
        </h2>
        <a
          className="inline-block bg-gradient-to-r from-blue-500 to-indigo-600 text-white px-6 py-3 rounded-lg shadow-lg hover:shadow-xl hover:bg-indigo-700 transition duration-300"
          href="https://aifinitelearning.com/"
          target="_blank"
        >
          Explore Available Courses
        </a>
      </div>
      <div className="bg-white shadow-md rounded-lg p-6">
        <h2 className="text-2xl font-semibold text-gray-800 mb-3">
          Helpful Resources 📚
        </h2>
        <p className="text-gray-600 mb-3">
          Need assistance? Explore these resources:
        </p>
        <ul className="list-none space-y-2">
          <li>
            <a href="/" className="text-blue-500 font-medium hover:underline">
              ➤ FAQs
            </a>
          </li>
          <li>
            <a href="/" className="text-blue-500 font-medium hover:underline">
              ➤ Contact Support
            </a>
          </li>
          <li>
            <a href="/" className="text-blue-500 font-medium hover:underline">
              ➤ Join the Forums
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Dashboard;
